import { render, staticRenderFns } from "./InsightAttend.vue?vue&type=template&id=a1be8630"
import script from "./InsightAttend.vue?vue&type=script&lang=js"
export * from "./InsightAttend.vue?vue&type=script&lang=js"
import style0 from "./InsightAttend.vue?vue&type=style&index=0&id=a1be8630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports